
<template>
  <div class="listcontainer" style="height:100%">
    <div class="cardcontainer" style="height:100%">
      <draggable ref="draggableelement" v-bind="dragOptions" class="fab-menu-inner" filter=".ignore-elements" tag="div" :group="{ name: 'description', put: true }" @add="add" @start="dragStart" @end="dragEnd" @update="dragUpdated" style="height:100%">
        <slot></slot>

        <div class="card mx-0 px-0 skin shadow-1 rounded" :key="el.id" v-for="(el, index) in cards" :id="el.id">

          <div style="position:absolute;right:8px; top:8px;" class="">
            <div class="skinnedmenu dropdown" v-bind:class="menuclass" style="position:relative">
              <a href="#" class="caret-0 px-0" data-toggle="dropdown" data-boundary="viewport" id="headerlink" style="color: inherit;">
                <span class="badge badge-pill px-0" style="background-color:#E8E8E8">
                  <i class="icon-arrow-down22" style="color: inherit; margin-left: -1px; width: 26px; height: 15px; }"></i>
                </span>
              </a>
              <div class="skinnedmenu dropdown-menu viewportfix pt-1" v-bind:class="menuclass" style="position:absolute">
                <a v-show="el.Locked == true" class="dropdown-item">
                  Unable to edit tasks in the future
                </a>

                <a v-show="el.Locked == false && el.ParentProcedureId != null && el.IsOwner == true" v-bind:href="'javascript:procedureDetail(' + el.ParentProcedureId + ',' + el.ProcedureScheduleId + ',' + index + ',' + true + ',\'' + el.AssignTo + '\',' + el.SchMessagesCount + ',' + el.IsShiftTask +')'" class="dropdown-item">{{el.Lables[0]}}</a>

                <a v-show="el.Locked == false  && el.ParentProcedureId == null && el.IsOwner == true" v-bind:href="'javascript:procedureDetail(' + el.ProcedureId + ',' + el.ProcedureScheduleId + ',' + index + ',' + true + ',\'' + el.AssignTo + '\',' + el.SchMessagesCount + ',' + el.IsShiftTask + ')'" class="dropdown-item">{{el.Lables[0]}}</a>
                <a v-show="el.Locked == false" v-bind:href="'javascript:assignProcedureSchedule(' + el.ProcedureScheduleId + ',' + index+')'" class="dropdown-item">{{el.Lables[1]}}</a>
                <a v-show="el.Locked == false" v-bind:href="'javascript:assignProcedureSchedule(' + el.ProcedureScheduleId + ',' + index+ ',' + true +',' + true + ')'" class="dropdown-item">{{el.Lables[2]}}</a>

                <a v-if="el.IsTask == true && el.Locked == false && el.IsOwner == true && el.ParentProcedureId == null" v-bind:href="'javascript:convertToProcedure(\'' + el.ProcedureId + '\')'" class="dropdown-item">{{el.Lables[4]}}</a>
                <a v-show="el.Locked == false" v-bind:href="'javascript:deleteScheduling(' + el.ProcedureScheduleId + ')'" class="dropdown-item">{{el.Lables[3]}}</a>

              </div>
            </div>
          </div>

          <div class="card-header pb-0 pt-2 px-2 cursor-pointer" @click="procedureDetail(el.ActualProcedureId,el.ProcedureScheduleId,index,false,el.AssignTo,el.SchMessagesCount,el.IsShiftTask)" v-if="el.header && el.header != null" v-html="el.header" style="color: #44A5BB"></div>
          <div class="card-body pb-2 px-2">
            <h5 class="card-title py-0 mb-0" v-if="el.title && el.title != null" v-html="el.title">Primary card title</h5>
            <p class="card-text py-0" v-if="el.text && el.text != null" v-html="el.text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            <div class="error" v-if="!el.id || el.id == null">Error: id-attribute is missing</div>
            <div style="float: right;">
              <img v-bind:src="getApiBaseUrl() +'/api/Memberships/v1/Color?color='+ el.priority[1]" alt="" width="15" height="15" class="rounded-circle mr-2" style="margin-right: 2px !important; margin-top: -4px;" />
              <span v-html="el.priority[0]" class="pl-1"></span>
            </div>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>

  import draggable from "vuedraggable";

  export default {
    name: 'card-list-new',
    components: {
      draggable
    },
    data() {
      return {
        cards: [],
        idGlobal: 1,
        message: "init",
        activeSubMenu: null,
      }
    },
    props:
    {
      oncardschange: {
        required: false,
        type: String,
        default: null
      },
    }
    ,
    methods: {
      getApiBaseUrl() {
        return Vue.prototype.$hostname;
      },
      procedureDetail(ActualProcedureId, ProcedureScheduleId,
        index, isbool, AssignTo, SchMessagesCount, IsShiftTask) {
        //js function
        procedureDetail(ActualProcedureId, ProcedureScheduleId,
          index, isbool, AssignTo, SchMessagesCount, IsShiftTask);
      },

      toggleShow(id) {
        this.activeSubMenu = id;
        $(id).toggleClass("show");
      },
      getId() {
        return this._uid;
      },
      setCards(cards) {
        this.cards = cards;
      },
      dragStart() {

      },
      add(event) {
        this.doChange(event, "add")
      },

      dragEnd(event) {

      },

      dragUpdated(event) {
        this.doChange(event, "update")
      },

      cloneElement({ }) {
        return {

        };
      },

      doChange(event, source) {
        this.message = source
        var changedElementId = null;
        if (event.item && event.item != null)
          changedElementId = event.item.id;
        else if (event.dragged && event.dragged != null)
          changedElementId = event.dragged.id;
        var targetIds = [];
        var draggableContainer = this.$refs.draggableelement.$el;
        for (var i = 0; i < draggableContainer.childNodes.length; i++) {
          var childNode = draggableContainer.childNodes[i];
          if (childNode.id && childNode.id != null && childNode.id != "") {
            var eids = childNode.id.split('-');
            targetIds.push(eids[0]);//childNode.id);
          }
        }
        var ids = changedElementId.split('-');
        var changeEvent = {
          targetElements: targetIds,
          target: this.$el.id,
          added: ids[0],//changedElementId,
          procedureId: ids[1],
          source: source,
        };
        console.log(changeEvent);
        if (this.oncardschange != null)
          eval(this.oncardschange + '(changeEvent);');
      }
    },
    created() {

    },
    mounted() {

    },
    computed: {
      dragOptions() {
        return {
          sort: true,
          disabled: false,
          ghostClass: "ghost",
          animation: 500,
        };
      },
    }
  }
</script>
<style scoped>

  .adminmenu::after {
    content: "\A";
    position: absolute;
    width: 68%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.06);
    /*opacity: 1;
    transition: all 1s;
    -webkit-transition: all 1s;*/
    border-radius: 50rem !important;
  }

  .adminmenu:hover::after {
    background: rgba(0,0,0,.1);
    /*transition: all 1s;
    -webkit-transition: all 1s;*/
    border-radius: 50rem !important;
  }

  .icon-menu {
    color: #a4a4a4;
  }

  .footable-toggle {
    display: none;
  }

  .mouseover-ul {
    /*color: #7c7c7c !important;*/
  }

    .mouseover-ul:hover {
      text-decoration: underline !important;
      cursor: pointer;
    }

  .skin th:first-of-type {
    padding-left: 0px;
  }

  tbody tr td {
    cursor: pointer;
  }

  .table-active {
    border-bottom: 1px solid #ccc;
  }

  .dropleft .dropdown-toggle::before {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/cards/card-list-new.vue